import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface RoomStoreState {
  // 逆ネーター用
  roomId?: string;
  setRoomId: (roomId?: string) => void;
  // ウミガメ用
  umigameRoomId?: string;
  setUmigameRoomId: (umigameRoomId?: string) => void;
}

export const useRoomStore = create<RoomStoreState>()(
  devtools((set) => ({
    // 逆ネーター用
    roomId: undefined,
    setRoomId: (roomId?: string) => set(() => ({ roomId })),
    // ウミガメ用
    umigameRoomId: undefined,
    setUmigameRoomId: (umigameRoomId?: string) =>
      set(() => ({ umigameRoomId })),
  })),
);
